import React from 'react'
import {useHistory} from 'react-router-dom'
import Chip from '@mui/material/Chip'

export default function FilterChip(props) {

  const history = useHistory()
  const {name, createLabel = a => a, context, onDelete, from} = props

  const label = createLabel(context.query[name])

  function handleDelete () {
    const query = {...context.query, [name]: undefined}
    history.push(context.link(undefined, undefined, {query}))
  }

  return (<Chip label={label} onDelete={onDelete || handleDelete} className="filter-chip" />)
}

